module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/new/assessment_achievements/2@2x_288b5f8810253addbef8180f8181eb87.png";